export const FORM_IDENTIFIER = 'app/DonationMatchingRulesFormPage';

export const INIT = 'app/DonationMatchingRulesFormPage/INIT';
export const INIT_SUCCESS = 'app/DonationMatchingRulesFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationMatchingRulesFormPage/INIT_FAILED';

export const SAVE = 'app/DonationMatchingRulesFormPage/SAVE';
export const SAVE_SUCCESS = 'app/DonationMatchingRulesFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/DonationMatchingRulesFormPage/SAVE_FAILED';

export const REMOVE = 'app/DonationMatchingRulesFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/DonationMatchingRulesFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/DonationMatchingRulesFormPage/REMOVE_FAILED';
